const VuexTypes = Object.freeze({
  ORDERS_LIST: 'ORDERS_LIST',
  ORDERS_LIST_FILTERS: 'ORDERS_LIST_FILTERS',
  ORDERS_CLASSIFIERS: 'ORDERS_CLASSIFIERS',
  ORDER_UPDATE_DATA: 'ORDER_UPDATE_DATA',
  ORDER_UPDATE: 'ORDER_UPDATE',
  ORDER_CREATE: 'ORDER_CREATE',
  ORDER_DELETE: 'ORDER_DELETE',
  ORDER_COPY: 'ORDER_COPY',
  ORDER_ATTACHMENTS: 'ORDER_ATTACHMENTS',
  ORDER_UPDATE_ATTACHMENTS_STATUS: 'ORDER_UPDATE_ATTACHMENTS_STATUS',
  ORDER_ADD_COMMENT_TO_ATTACHMENT: 'ORDER_ADD_COMMENT_TO_ATTACHMENT',
  ORDER_DELETE_ATTACHMENT: 'ORDER_DELETE_ATTACHMENT',
  ORDER_ACTIVITY: 'ORDER_ACTIVITY',
  ORDER_ITEMS: 'ORDER_ITEMS',
  ORDER_CREATE_ITEM: 'ORDER_CREATE_ITEM',
  ORDER_UPDATE_ITEM: 'ORDER_UPDATE_ITEM',
  ORDER_DELETE_ITEM: 'ORDER_DELETE_ITEM',
  ORDER_APPROVAL: 'ORDER_APPROVAL',
  ORDER_FACTS_AND_INVOICES_LIST: 'ORDER_FACTS_AND_INVOICES_LIST',
  ORDER_UPDATE_FACT: 'ORDER_UPDATE_FACT',
  ORDER_APPROVE_FACT_AND_INVOICE: 'ORDER_APPROVE_FACT_AND_INVOICE',
  ORDER_ITEMS_SEND_INVOICE_TO_BOOKKEEPER: 'ORDER_ITEMS_SEND_INVOICE_TO_BOOKKEEPER',
  ORDER_ITEMS_APPROVE_INVOICE_REVIEW: 'ORDER_ITEMS_APPROVE_INVOICE_REVIEW',
  ORDER_ITEMS_DECLINE_INVOICE_REVIEW: 'ORDER_ITEMS_DECLINE_INVOICE_REVIEW',
  ORDER_INVOICES_ADVANCE_LIST: 'ORDER_INVOICES_ADVANCE_LIST',
  ORDER_APPROVE_INVOICE_ADVANCE: 'ORDER_APPROVE_INVOICE_ADVANCE',
  ORDER_REMOVE_INVOICE_ADVANCE: 'ORDER_REMOVE_INVOICE_ADVANCE',
  ORDER_APPROVE_INVOICE_ADVANCE_REVIEW: 'ORDER_APPROVE_INVOICE_ADVANCE_REVIEW',
  ORDER_DECLINE_INVOICE_ADVANCE_REVIEW: 'ORDER_DECLINE_INVOICE_ADVANCE_REVIEW',
  ORDER_SEND_INVOICE_ADVANCE_TO_BOOKKEEPER: 'ORDER_SEND_INVOICE_ADVANCE_TO_BOOKKEEPER',
});

export default VuexTypes;
